const FETCH_USER_REWARDS = "user/rewards/FETCH_USER_REWARDS";
const FETCH_USER_REWARDS_SUCCESS = "user/rewards/FETCH_USER_REWARDS_SUCCESS";
const FETCH_USER_REWARDS_FAIL = "user/rewards/FETCH_USER_REWARDS_FAIL";
const UPDATE_USER_REWARDS = "user/rewards/UPDATE_USER_REWARDS";
const UPDATE_USER_REWARDS_SUCCESS = "user/rewards/UPDATE_USER_REWARDS_SUCCESS";
const UPDATE_USER_REWARDS_FAIL = "user/rewards/UPDATE_USER_REWARDS_FAIL";
const SUBMIT_USER_REWARDS = "user/rewards/SUBMIT_USER_REWARDS";
const SUBMIT_USER_REWARDS_SUCCESS = "user/rewards/SUBMIT_USER_REWARDS_SUCCESS";
const SUBMIT_USER_REWARDS_FAIL = "user/rewards/SUBMIT_USER_REWARDS_FAIL";

const initialState = {
  pending: true,
  loaded: false,
  rewards: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_USER_REWARDS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_USER_REWARDS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        dirty: false,
        oldRewards: { ...action.results },
        rewards: { ...action.results },
        errors: null
      });
    case FETCH_USER_REWARDS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case UPDATE_USER_REWARDS:
      return Object.assign({}, state, {
        dirty: true,
        rewards: action.rewards
      });
    case UPDATE_USER_REWARDS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        rewards: { ...action.results },
        errors: null
      });
    case UPDATE_USER_REWARDS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case SUBMIT_USER_REWARDS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case SUBMIT_USER_REWARDS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        oldRewards: { ...action.results },
        rewards: { ...action.results },
        dirty: false,
        errors: null
      });
    case SUBMIT_USER_REWARDS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    default:
      return state;
  }
}

export function fetchUserRewardsPending() {
  return {
    type: FETCH_USER_REWARDS
  };
}

export function fetchUserRewardsSuccess(results) {
  return {
    type: FETCH_USER_REWARDS_SUCCESS,
    results
  };
}

export function fetchUserRewardsFail(errors) {
  return {
    type: FETCH_USER_REWARDS_FAIL,
    errors
  };
}

export function updateUserRewards(rewards) {
  return {
    type: UPDATE_USER_REWARDS,
    rewards
  };
}

export function updateUserRewardsSuccess(results) {
  return {
    type: UPDATE_USER_REWARDS_SUCCESS,
    results
  };
}

export function updateUserRewardsFail(errors) {
  return {
    type: UPDATE_USER_REWARDS_FAIL,
    errors
  };
}

export function submitUserRewardsPending() {
  return {
    type: SUBMIT_USER_REWARDS
  };
}

export function submitUserRewardsSuccess(results) {
  return {
    type: SUBMIT_USER_REWARDS_SUCCESS,
    results
  };
}

export function submitUserRewardsFail(errors) {
  return {
    type: SUBMIT_USER_REWARDS_FAIL,
    errors
  };
}

export const getRewards = state => state.rewards;
export const getValidRewards = state => state.oldRewards;
export const getRewardsError = state => state.errors;
export const getRewardsPending = state => state.pending;
export const getRewardsLoaded = state => state.loaded;
export const getRewardsDirty = state => state.dirty;
